import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";
import { CalculationState } from "../../../entities/Calculation";

export const getRoot = (state: RootState) => state.calculation;

export const getDataFromCalculation = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation,
);

export const getCalculationError = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.error,
);

export const getInitialCalculationIsCompleted = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.calculationRequestCount >= 2,
);

export const getCalculationLoading = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.isLoading,
);

export const getCurrencyShortName = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.currencyShortName,
);

export const getCountryMeasureUnit = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.countryMeasureUnit,
);

export const getCalculatedPrices = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.prices,
);

export const getCalculatedVolume = createSelector(
  [getRoot],
  (calculation: CalculationState) => calculation.volume,
);
